import { useState } from 'react';
import { UserTable } from './UserTable';
import { UserModal } from './UserModal';
import './team-modern.css';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  permissions: string[];
  role: 'Owner' | 'Staff';
  active: boolean;
}

export default function TeamManagement() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAddUser = () => {
    setSelectedUser(null);
    setIsModalOpen(true);
  };

  const handleEditUser = (user: any) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const refreshUsers = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="page-content tailwind-prefix team-page">
      <div className="team-page__shell">
        <main className="team-page__content">
          <UserTable
            key={refreshKey}
            onAddUser={handleAddUser}
            onEditUser={handleEditUser}
          />
        </main>
      </div>

      <UserModal
        isOpen={isModalOpen}
        onClose={() => {
          handleCloseModal();
          refreshUsers();
        }}
        user={selectedUser}
      />
    </div>
  );
}
